<template>
  <div class="btn-box">
    <div @click="addBtn" class="add-btn">添加</div>

    <!-- 查询 -->
    <el-popover width="740" v-model="searchVisible" placement="bottom-start" trigger="click">
      <div slot="reference" @click="searchBtn" class="add-btn">查询</div>
      <SearchList v-if="searchVisible" :isCascade="isCascade" :searchVisible.sync='searchVisible'
        :defaultProps='defaultProps' :formList='searchList' @searchFormData='searchFormData' :searchForm='searchForm'
        :selectDict='selectDict' />
    </el-popover>

    <div @click="resetBtn" class="add-btn">重置</div>

  </div>
</template>

<script>
import SearchList from "@/views/profile/components/mine/myUpload/common/SearchList";
export default {
  name: "HeadBtn",
  components: {
    SearchList,
  },
  props: {
    selectDict: {},
    searchForm: {},
    searchList: {},
    defaultProps: {},
    //是否调用基础级联--------------------------------------------
    isCascade: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },

  data() {
    return {
      //查询是否可见--------------------------------------------
      searchVisible: false,
    };
  },

  methods: {
    addBtn() {
      this.$emit("addBtn");
    },
    searchBtn() {
      this.$emit("searchBtn");
    },
    resetBtn() {
      this.$emit("resetBtn");
    },

    searchFormData(searchFormData) {
      this.$emit("searchFormData", searchFormData);
    },
  },
};
</script>

<style lang="less" scoped>
.btn-box {
  display: flex;

  .add-btn {
    border-radius: 5px;
    width: 60px;
    height: 30px;
    margin-bottom: 20px;
    margin-right: 20px;

    font-size: 16px;
    line-height: 30px;
    text-align: center;

    color: #fff;
    background-color: #24ba58;

    cursor: pointer;
    user-select: none;

    &:hover {
      box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.2);

      transform: translateY(-1px);
    }
  }
}
</style>